module.exports = __webpack_public_path__ + "img/home-icon-active.49303ee9.svg";